/*
 * NC Motion — UN solo IntersectionObserver global para los reveals de texto (assets/nc-motion.css).
 * Cada elemento se revela una vez (agrega .nc-in y deja de observarse). Los que entran juntos escalonan 90 ms.
 * Sin listeners de scroll. Solo actúa si <html> tiene .nc-motion (IntersectionObserver disponible y sin reduced-motion).
 * Al arrancar marca <html> con .nc-motion-ready: desactiva la red de seguridad temporal del CSS (que solo existe por si este
 * script nunca carga) para que los textos fuera de pantalla esperen su scroll.
 */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('nc-motion') || !('IntersectionObserver' in window)) return;

  var SEL = [
    '.ncpcr__titles > *', '.ncbs__heading', '.ncbs__sub', '.ncbs__offer', '.nceb__eyebrow', '.nceb__heading', '.nceb__sub',
    '.ncpk__heading', '.ncpk__copy', '.nct__title',
    '.ncch__eyebrow', '.ncch__title', '.ncch__desc', '.nc-colhead__eyebrow', '.nc-colhead__title', '.nc-colhead__desc',
    '.nc-pdp__details-head > *', '.nc-pdp__story-eyebrow', '.nc-pdp__story h2', '.nc-pdp__story p', '.ncb--pdp .ncb__heading', '.ncr__eyebrow', '.ncr__heading',
    '.nc3x2__eyebrow', '.nc3x2__title', '.nc3x2__sub', '.nc3x2__copy',
    '.ncpw__eyebrow', '.ncpw__title', '.ncpw__text'
  ].join(',');

  var io = new IntersectionObserver(function (entries) {
    var visible = entries.filter(function (e) { return e.isIntersecting; });
    visible.sort(function (a, b) {
      return a.target.compareDocumentPosition(b.target) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    visible.forEach(function (entry, i) {
      entry.target.style.setProperty('--nc-d', i * 90 + 'ms');
      entry.target.classList.add('nc-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });

  function scan(scope) {
    (scope || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.__ncMotion || el.classList.contains('nc-in')) return;
      el.__ncMotion = true;
      io.observe(el);
    });
  }

  function start() { scan(); root.classList.add('nc-motion-ready'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  // Theme Editor y secciones renderizadas después de la carga.
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
